/* eslint-disable react/react-in-jsx-scope */
import style from './moreRecipientsChip.module.css'

export default function MoreRecipientsChip({numberOfRecipients, onClick})  {
    return (
      <div className={style.item} onClick = {onClick}>
        {`+${numberOfRecipients} more`}
      </div>
    );
};